<template>
    <div class="tree-menu">

        <div @click.stop="expanded = !expanded"
             class="node child-margin"

        >
            <span v-if="hasChildren"
                  class="type">
                {{expanded ? '&#9660;' : '&#9658;'}}
            </span>
            <span class="title-tree">
                <span>{{node.nodeDescription}}</span>
            </span>

            <tree-menu v-if="expanded"
                       v-for="(child, i) in node.childNodeList"
                       :key="i+ '' + child.nodeType"
                       :node="child"
                       :depth="depth + 1">
            </tree-menu>

            <!--<div  :style="{'margin-left': `${depth * 12}px` }"-->
            <div
                 v-if="expanded" v-for="(changeList, i) in node.fieldChangeList"
                 :key="i" :class="i" class="change-list">

                    <div class="change">
                        <div class="margin-left-l" v-if="changeList.fieldSeverity === 'WARNING'">  <v-icon color="warning">warning</v-icon></div>
                        <div class="margin-left-l" v-if="changeList.fieldSeverity === 'ERROR'">  <v-icon color="error">error</v-icon></div>
                        <div class="margin-left-l" v-if="changeList.fieldSeverity === 'INFO'">  <v-icon color="info">info</v-icon></div>
                        <div class="margin-left-l" v-if="changeList.fieldSeverity === 'SUCCESS'">  <v-icon color="success">success</v-icon></div>

                        <div class="description" v-if="changeList.fieldDescription !== null" v-html="changeList.fieldDescription">
                        </div >
                        <div class="description" v-else>null</div>
                    </div>

                    <div class="diff" v-if="changeList.fieldDiff !== null">
                        <span>Diff: </span><span  v-html="changeList.fieldDiff">
                        </span>
                    </div>
            </div>


        </div>




    </div>
</template>

<script>

    export default {
        name: "tree-menu",
        props: {
            node: Object,
            change: '',
            depth: {
                type: Number,
                default: 0
            }
        },
        data() {
            return {
                expanded: true
            }
        },
        computed: {
            hasChildren() {

                if(this.node.childNodeList.length > 0 || this.node.fieldChangeList.length >0)
                return this.node.childNodeList
            }

        },
        methods: {

        }
    }
</script>

<style lang="scss" scoped>

    .child-margin {
        margin-left: 30px;
    }

    .diff {
        margin-left: 3.6rem !important;
    }

    .change-list .change {
        display: flex;

        .description {
            margin-left: 4px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/professional/components/tests/TreeMenu.vue